var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"video",staticClass:"video"},[(_vm.error)?_c('div',{staticClass:"error"},[_vm._v("Video Not Found")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }